var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (style) {
buf.push("<div v-show=\"show\" v-on=\"dblclick: hide\" data-alert" + (jade.cls(['alert','alert-box','secondary',style.alert], [null,null,null,true])) + "><span v-if=\"server.wait\">Загрузка данных с SOAP-сервера &nbsp;<i class=\"fa fa-refresh fa-spin\"></i>&nbsp; {{ message }}</span><span v-if=\"server.error\">Ошибка на SOAP-сервере&nbsp;<i class=\"fa fa-ban\"></i>&nbsp; {{ message }}</span><span v-if=\"client.parse\">Парсинг даных с SOAP-сервера&nbsp;<i class=\"fa fa-cog fa-spin\"></i>&nbsp; {{ message }}</span><span v-if=\"client.error\">Ошибка парсинга данных с SOAP-сервера &nbsp;<i class=\"fa fa-exclamation-circle\"></i>&nbsp; {{ message }}</span><span v-if=\"form.error\"><p" + (jade.cls([style.text], [true])) + ">{{{ message }}}</p></span></div>");}.call(this,"style" in locals_for_with?locals_for_with.style:typeof style!=="undefined"?style:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/alert-dialog/template.jade
 ** module id = 16
 ** module chunks = 0
 **/